import actions from "./actionTypes";

export const displayMessageAction = message => {
  return {
    type: actions.DISPLAY_MESSAGE,
    payload: message
  };
};

export const requestDisplaySuccessMessageAction = (text, delay) => {
  return {
    type: actions.REQUEST_DISPLAY_MESSAGE,
    payload: {
      text,
      type: "success"
    },
    delay
  };
};

export const requestDisplayErrorMessageAction = (text, delay) => {
  return {
    type: actions.REQUEST_DISPLAY_MESSAGE,
    payload: {
      text,
      type: "error"
    },
    delay
  };
};

export const resetMessageAction = () => {
  return {
    type: actions.RESET_MESSAGE
  };
};
